import { IpexViewerComponent } from '../IpexViewerComponent';
import { SystemBase } from '@inter-ikea-core/core-toolbox';
import { ComponentIds, DisplayNameComponent, HierarchyUtils, LocalTransformComponent, MathUtils, Transform, UnserializableEntityComponent } from '@inter-ikea-core/core';
import { CameraComponent } from './CameraComponent';
import { getIpexViewer, toVector, toVectorUnscaled } from '../util';
export class CameraUpdateSystem extends SystemBase {
    sceneManager;
    entityManager;
    doingChangesOnComponent = [CameraComponent.ID, ComponentIds.LOCAL_TRANSFORM_COMPONENT_ID];
    id = 'CameraUpdateSystem';
    systemsAfterMe = null;
    systemsBeforeMe = null;
    constructor(sceneManager, entityManager) {
        super(IpexViewerComponent.ID);
        this.sceneManager = sceneManager;
        this.entityManager = entityManager;
        const preExistingViewer = getIpexViewer(sceneManager);
        if (preExistingViewer)
            this.createCamera(preExistingViewer);
    }
    onAddComponent(_entity, newComponent) {
        this.createCamera(newComponent.viewer);
    }
    onRemoveComponent(_entity, _oldComponent) {
        const camera = this.getCamera();
        if (!camera)
            return;
        this.entityManager.disposeEntity(camera);
    }
    onUpdateComponent(entity, oldComponent, newComponent) {
        this.onRemoveComponent(entity, oldComponent);
        this.onAddComponent(entity, newComponent);
    }
    createCamera(ipexViewer) {
        ipexViewer.get_camera_updated_observable().add(this.handleCameraUpdate);
        const camera = this.entityManager.createEntity();
        camera.addComponent(new CameraComponent());
        camera.addComponent(new DisplayNameComponent('Camera'));
        /*
        We might want to be able to save the camera position in some planners. That would require setting the viewer camera
        to the correct position when loading. We'd also need to save the camera to the scene instead of root.
         */
        camera.addComponent(new UnserializableEntityComponent());
        HierarchyUtils.setParent(camera, this.sceneManager.root);
        this.handleCameraUpdate(ipexViewer.get_camera_state());
    }
    /**
     * Updates the transform of the camera entity, so we have easy access to it from pure ECS without polling the viewer
     */
    handleCameraUpdate = (cameraState) => {
        const ipexViewer = getIpexViewer(this.sceneManager);
        if (!ipexViewer)
            return;
        const camera = this.getCamera();
        if (!camera)
            return;
        const cameraPosition = toVector(cameraState.position);
        const cameraMatrix = cameraState.get_view_matrix();
        const cameraRotation = MathUtils.quaternionFromBaseVectors(
        // we invert (transpose as we have unit vectors) the view matrix to get the camera matrix
        toVectorUnscaled({ x: cameraMatrix[0].x, y: cameraMatrix[1].x, z: cameraMatrix[2].x }), // right
        toVectorUnscaled({ x: cameraMatrix[0].y, y: cameraMatrix[1].y, z: cameraMatrix[2].y }), // up
        toVectorUnscaled({ x: cameraMatrix[0].z, y: cameraMatrix[1].z, z: cameraMatrix[2].z }) // forward
        );
        const newLocalTransform = new LocalTransformComponent(new Transform(cameraPosition, cameraRotation));
        camera.addComponent(newLocalTransform);
    };
    getCamera() {
        return HierarchyUtils.children(this.sceneManager.root).find(it => it.hasComponent(CameraComponent.ID));
    }
}
//# sourceMappingURL=CameraUpdateSystem.js.map